export const firebaseConfig = {
  apiKey: 'AIzaSyBwJASCv7cqXI6UGI4Qb2OWDdrxkIGQs5Y',
  authDomain: 'bokstavo.firebaseapp.com',
  projectId: 'bokstavo',
  storageBucket: 'bokstavo.firebasestorage.app',
  messagingSenderId: '384142055304',
  appId: '1:384142055304:web:33f7b7bb75fd5ae16f0c3d',
};

export const appCheckSiteKey = '6LdMI0ErAAAAADE5DmUnK_6LaMflttKU_XwAjnlv';
